<template>
  <!-- 消息区 - 详情 -->
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-if="0" label="消息区" name="first">
        <!-- <template v-if="message && message.length"> -->
          <div class="msg-box" v-if="currentData">
            <div class="box-header">
              <div>
                <span class="title cursor" @click="jjSearch(currentData)">{{currentData.siteName}}</span>
                <span>总量：{{currentData.num}}
                  <span
                    style="margin-left:10px;"
                    class="st"
                    :class="{
                      'blue': getSiteStatus(currentData.num,currentData.siteBikeCeiling).style === 0,
                      'warning': getSiteStatus(currentData.num,currentData.siteBikeCeiling).style === 1,
                      'red': getSiteStatus(currentData.num,currentData.siteBikeCeiling).style === 2,
                      'origin': getSiteStatus(currentData.num,currentData.siteBikeCeiling).style === 3,
                    }">
                    {{getSiteStatus(currentData.num,currentData.siteBikeCeiling).status}}
                  </span>
                </span>
              </div>
              <span class="t" v-if="currentData.createTime">{{currentData.createTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
            </div>
            <div class="box-body">
              <ul>
                <li class="title">自行车：{{currentData.bikeNum || 0}}</li>
                <template v-if="currentData.currentBike && currentData.currentBike.nowBike">
                  <li v-for="(it,index) in currentData.currentBike.nowBike" :key="'a'+index+currentData.id">{{it.brand_name}}: {{it.num}}</li>
                </template>
                <li v-else>暂无数据</li>
              </ul>
              <ul>
                <li class="title">电动车：{{currentData.ebikeNum || 0}}</li>
                <template v-if="currentData.currentBike && currentData.currentBike.nowEBike">
                  <li v-for="(it,index) in currentData.currentBike.nowEBike" :key="'a'+index+currentData.id">{{it.brand_name}}: {{it.num}}</li>
                </template>
                <li v-else>暂无数据</li>
              </ul>
            </div>
          </div>
          <div v-else>暂无数据</div>
        <!-- </template> -->
      </el-tab-pane>
      <el-tab-pane label="历史消息" name="second">
        <template v-if="messageData && messageData.length">
          <div class="msg-box" v-for="(item,index) in messageData" :key="'b'+index">
            <div class="box-header">
              <div>
                <span class="title cursor" @click="jjSearch(item)">{{item.siteName}}</span>
                <span>总量：{{item.num}}
                  <span
                    style="margin-left:10px;"
                    class="st"
                    :class="{
                      'blue': getSiteStatus(item.num,item.siteBikeCeiling).style === 0,
                      'warning': getSiteStatus(item.num,item.siteBikeCeiling).style === 1,
                      'red': getSiteStatus(item.num,item.siteBikeCeiling).style === 2,
                      'origin': getSiteStatus(item.num,item.siteBikeCeiling).style === 3,
                    }">
                    {{getSiteStatus(item.num,item.siteBikeCeiling).status}}
                  </span>
                </span>
              </div>
              <span class="t">{{item.createTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
            </div>
            <div class="box-body">
              <ul>
                <li class="title">自行车：{{item.bikeNum || 0}}</li>
                <template v-if="item.currentBike && item.currentBike.nowBike">
                  <li v-for="(it,index) in item.currentBike.nowBike" :key="'a'+index+item.id">{{it.brand_name}}: {{it.num}}</li>
                </template>
                <li v-else>暂无数据</li>
              </ul>
              <ul>
                <li class="title">电动车：{{item.ebikeNum || 0}}</li>
                <template v-if="item.currentBike && item.currentBike.nowEBike">
                  <li v-for="(it,index) in item.currentBike.nowEBike" :key="'a'+index+item.id">{{it.brand_name}}: {{it.num}}</li>
                </template>
                <li v-else>暂无数据</li>
              </ul>
            </div>
          </div>
        </template>

        <!-- <div>暂无数据</div> -->

        <el-pagination
          style="margin-top: 15px; text-align: right;"
          @size-change="handleSizeChange"
          @current-change="handlePageNoChange"
          :page-sizes="pageSizes"
          :layout="layout"
          :total="total"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import Api from '@/api'
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  props: ['typeName', 'siteMessage', 'currentData', 'fullPileNum'],
  data() {
    return {
      messageData: [],
      activeName: 'second',
      pageNo: 1,
      pageSizes: [100, 200, 500],
      pageSize: 100,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      message: []
    }
  },
  computed: {
    ...mapGetters(['selfAreaId'])
  },
  created() {
    if (this.activeName === 'first') {
      this.initData()
    } else if (this.activeName === 'second') {
      this.getHistoryList()
    }
  },
  methods: {
    handleSizeChange(sise) {
      this.pageSize = sise
      this.getHistoryList()
    },
    handlePageNoChange(page) {
      this.pageNo = page
      this.getHistoryList()
    },
    handleDd() {
      alert('handleDd')
    },
    handleClick(tab, event) {
      const name = tab.name
      if (name === 'first') {

      } else if (name === 'second') {
        this.getHistoryList()
      }
    },
    getHistoryList() {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId,
        currentPage: vm.pageNo,
        pageSize: vm.pageSize,
        siteId: vm.currentData.siteId
      }
      Api.siteHistory(params)
        .then(res => {
          if (res.code === 200) {
            vm.messageData = res.data.lists.map(item => {
              item.currentBike = item.currentBike && JSON.parse(item.currentBike)
              item.bikeNum = item.currentBike && item.currentBike.nowBike && item.currentBike.nowBike.reduce((pre, curr) => pre + curr.num, 0)
              item.ebikeNum = item.currentBike && item.currentBike.nowEBike && item.currentBike.nowEBike.reduce((pre, curr) => pre + curr.num, 0)
              return item
            })
            vm.total = res.data.total
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
    },
    jjSearch(item) {
      this.$emit('jjSearch', item)
    },
    initData() {
      if (this.currentData) {
        if (this.currentData.currentBike && !this.currentData.fromAmap) {
          try {
            this.currentData.currentBike = JSON.parse(this.currentData.currentBike)
          } catch (err) {
            console.log('components-listbox-messagelist-initData', this.currentData, err)
          }
          this.currentData.bikeNum = this.currentData.currentBike && this.currentData.currentBike.nowBike && this.currentData.currentBike.nowBike.reduce((pre, curr) => pre + curr.num, 0)
          this.currentData.ebikeNum = this.currentData.currentBike && this.currentData.currentBike.nowEBike && this.currentData.currentBike.nowEBike.reduce((pre, curr) => pre + curr.num, 0)
        } else if (this.currentData && this.currentData.fromAmap) {
          this.currentData.currentBike = {}
          if (this.currentData.brandBike.length) {
            this.currentData.bikeNum = this.currentData.brandBike.reduce((pre, curr) => pre + curr.siteNum, 0)
            this.currentData.currentBike.nowBike = []
            this.currentData.brandBike.forEach(item => {
              const temp = {
                brand_name: item.brandName,
                num: item.siteNum
              }
              this.currentData.currentBike.nowBike.push(temp)
            })
          }
          if (this.currentData.brandEBike.length) {
            this.currentData.ebikeNum = this.currentData.brandEBike.reduce((pre, curr) => pre + curr.siteNum, 0)
            this.currentData.currentBike.nowEBike = []
            this.currentData.brandEBike.forEach(item => {
              const temp = {
                brand_name: item.brandName,
                num: item.siteNum
              }
              this.currentData.currentBike.nowEBike.push(temp)
            })
          }
          this.currentData.num = this.currentData.bikeNum + this.currentData.ebikeNum
        } else {
          this.currentData.currentBike = {}
          this.currentData.bikeNum = 0
          this.currentData.ebikeNum = 0
        }
      }
    },
    onShowDialog2(item) {
      const data = {
        ...item,
        type: 'bikes'
      }
      this.$emit('onShowDialog2', data)
    },
    getSiteStatusNew(messageType) {
      return {
        empty: {
          style: 0,
          status: '空桩'
        },
        less: {
          style: 1,
          status: '偏少'
        },
        more: {
          style: 3,
          status: '偏多'
        },
        full: {
          style: 2,
          status: '满桩'
        }
      }[messageType]
    },
    getSiteStatus(curr, total) {
      const obj = {
        style: '',
        status: ''
      }
      if (this.fullPileNum > 0) {
        if (curr === 0) {
          obj.style = 0 // 空桩  蓝色icon
          obj.status = '空桩'
        } else if (curr / (Math.floor(total * this.fullPileNum)) < 0.2) {
          obj.style = 1 // 偏少  绿色icon
          obj.status = '偏少'
        } else if (curr / (Math.floor(total * this.fullPileNum)) > 0.8 && curr / (Math.floor(total * this.fullPileNum)) < 1) {
          obj.style = 3 // 偏多  黄色icon
          obj.status = '偏多'
        } else if (curr / (Math.floor(total * this.fullPileNum)) >= 1) {
          obj.style = 2 // 满桩  红色icon
          obj.status = '满桩'
        } else {
          obj.style = 4 // 正常
          obj.status = '正常'
        }
        return obj
      }
      if (curr === 0) {
        obj.style = 0 // 空桩  蓝色icon
        obj.status = '空桩'
      } else if (curr / total < 0.2) {
        obj.style = 1 // 偏少  绿色icon
        obj.status = '偏少'
      } else if (curr / total > 0.8 && curr / total < 1) {
        obj.style = 3 // 偏多  黄色icon
        obj.status = '偏多'
      } else if (curr / total >= 1) {
        obj.style = 2 // 满桩  红色icon
        obj.status = '满桩'
      } else {
        obj.style = 4 // 正常
        obj.status = '正常'
      }
      return obj
    }
  }
}
</script>

<style lang="less">
  .msg-box + .msg-box {
    margin-top: 16px;
  }
  .msg-box {
    box-sizing: border-box;
    padding: 20px 16px;
    border: 1px solid #EBEBEB;
    .box-header {
      padding: 0 0 12px 0;
      display: flex;
      justify-content: space-between;
      span {
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,0.45);
      }
      .title {
        line-height: 1;
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:bold;
        color:#000;
        margin-right: 24px;
      }
      .t {
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,0.25);
      }
    }
    .box-body {
      display: flex;
      ul {
        flex: 1;
        li {
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(0,0,0,0.45);
          margin-top: 6px;
        }
        li.title {
          font-size:14px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:bold;
          color:#000;
        }
        span.blue {
          margin-left: 32px;
        }
      }
    }
  }
</style>
